import { workplaceConstants as wc } from 'srcReact/WorkplacePage'
import { alertActions } from 'srcReact/Alert'
import { userService, workplaceService } from 'srcReact/services'
import history from 'srcReact/helpers/history'
import { isEmpty } from 'srcReact/helpers/validator'

export const workplaceActions = {
  canAccess,
  create,
  approveInviteRequest,
  rejectInviteRequest
}

function canAccess(service, id, callbackAction, callbackSuccess, callbackFailure) {
  let serviceType
  let params

  switch (service) {
    case 'page-index-workplace':
      serviceType = 'CAN_ACCESS_INDEX_PAGE'
      params = id ? `workplace_id=${id}` : ''
      break
    case 'page-edit-workplace':
      serviceType = 'CAN_ACCESS_EDIT_PAGE'
      params = id ? `workplace_id=${id}` : ''
      break
    case 'page-create-workplace':
      serviceType = 'CAN_ACCESS_CREATE_PAGE'
      params = id ? `organization_id=${id}` : ''
      break
    case 'page-manage-workplace-invitation':
      serviceType = 'CAN_ACCESS_MANAGE_INVITE_PAGE'
      params = id ? `workplace_id=${id}` : ''
      break
    case 'page-member-list-workplace':
      serviceType = 'CAN_ACCESS_MEMBER_LIST_PAGE'
      params = id ? `workplace_id=${id}` : ''
      break
    case 'page-team-list-workplace':
      serviceType = 'CAN_ACCESS_TEAM_LIST_PAGE'
      params = id ? `workplace_id=${id}` : ''
      break
    default:
      return false
  }

  return (dispatch) => {
    dispatch(request(service, serviceType))

    userService.isAuthorized(service, params).then(
      (response) => {
        dispatch(success(response, serviceType))
        if (!isEmpty(callbackAction)) {
          dispatch(callbackAction())
        }
        if (typeof callbackSuccess === 'function') {
          callbackSuccess()
        }
      },
      (error) => {
        dispatch(failure(error, serviceType))
        if (typeof callbackFailure === 'function') {
          callbackFailure()
        }
      }
    )
  }

  function request(service, serviceType) {
    return { type: wc[`${serviceType}_REQUEST`], service }
  }
  function success(response, serviceType) {
    return { type: wc[`${serviceType}_SUCCESS`], response }
  }
  function failure(error, serviceType) {
    return { type: wc[`${serviceType}_FAILURE`], error }
  }
}

function create(organizationId, name, location, color, contentRestriction) {
  return (dispatch) => {
    dispatch(request({ organizationId, name, location, color, contentRestriction }))

    workplaceService.create(organizationId, name, location, color, contentRestriction).then(
      (response) => {
        dispatch(success(response))
        history.push(`/0/workplace/invite-members/${response.workplace.id}`)
        localStorage.setItem('workplaceNewlyCreated', response.workplace.id)
      },
      (error) => {
        dispatch(failure(error))
        dispatch(alertActions.error(error.message.toString()))
      }
    )
  }

  function request(response) {
    return { type: wc.CREATE_WORKPLACE_REQUEST, response }
  }
  function success(response) {
    return { type: wc.CREATE_WORKPLACE_SUCCESS, response }
  }
  function failure(error) {
    return { type: wc.CREATE_WORKPLACE_FAILURE, error }
  }
}

function approveInviteRequest(workplaceId, invitationIds) {
  return (dispatch) => {
    dispatch(request(workplaceId))

    workplaceService.approveInviteRequest(workplaceId, invitationIds).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }
  function request(response) {
    return { type: wc.APPROVE_INVITATION_REQUEST, response }
  }
  function success(response) {
    return { type: wc.APPROVE_INVITATION_SUCCESS, response }
  }
  function failure(error) {
    return { type: wc.APPROVE_INVITATION_FAILURE, error }
  }
}

function rejectInviteRequest(workplaceId, invitationIds) {
  return (dispatch) => {
    dispatch(request(workplaceId))

    workplaceService.rejectInviteRequest(workplaceId, invitationIds).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }
  function request(response) {
    return { type: wc.REJECT_INVITATION_REQUEST, response }
  }
  function success(response) {
    return { type: wc.REJECT_INVITATION_SUCCESS, response }
  }
  function failure(error) {
    return { type: wc.REJECT_INVITATION_FAILURE, error }
  }
}
